import { render, staticRenderFns } from "./CompetitionRatingPrizesCard.vue?vue&type=template&id=f4f74778&scoped=true"
import script from "./CompetitionRatingPrizesCard.vue?vue&type=script&lang=js"
export * from "./CompetitionRatingPrizesCard.vue?vue&type=script&lang=js"
import style0 from "./CompetitionRatingPrizesCard.vue?vue&type=style&index=0&id=f4f74778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f74778",
  null
  
)

export default component.exports